<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Custom Clearance Export</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button-group size="sm">
              <b-button
                :disabled="CC_EDI == '0' ? true : false"
                @click="gotToPage('EDI')"
                :variant="CC_EDI == '0' ? '' : 'success'"
                >EDI Execution</b-button
              >
              <b-button
                :disabled="CC_BL == '0' ? true : false"
                @click="gotToPage('BL')"
                :variant="CC_BL == '0' ? '' : 'success'"
                >B/L</b-button
              >
              <b-button
                :disabled="CC_PAY == '0' ? true : false"
                @click="gotToPage('PAY')"
                :variant="CC_PAY == '0' ? '' : 'success'"
                >Payment</b-button
              >
              <b-button
                :disabled="CC_HAND == '0' ? true : false"
                @click="gotToPage('HAND')"
                :variant="CC_HAND == '0' ? '' : 'success'"
                >Handover</b-button
              >
              <b-button
                :disabled="CC_VGM == '0' ? true : false"
                @click="gotToPage('VGM')"
                :variant="CC_VGM == '0' ? '' : 'success'"
                >VGM</b-button
              >

              <!--<b-button disabled>BL</b-button> -->
            </b-button-group>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="this.ALLMODULE ? this.ALLMODULE : ''"
          :jobSeriesBanner="this.JOBSERIES ? this.JOBSERIES : ''"
          :bannerClientName="this.getCLientData.length > 0 ? this.clientName : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ccImportId"
                  @click="addStatus"
                  style="position: fixed;z-index:9999;
    top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->
            <!-- <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="10">
            <label style="margin-top:15px">
              <u>Job Type</u>
            </label>
          </md-layout>

          <md-layout
            v-for="(segmentNameArray, index) in showSegmentArray"
            :key="index"
            :md-flex="segmentNameArray.flex"
          >
            <md-checkbox
              v-model="ffExoprtDetail.jobType[index]"
              class="md-primary"
              :md-value="segmentNameArray.value"
              :name="'jobType'+(index+1)"
              :id="'jobType'+(index+1)"
              @change="jobTypeSelect(segmentNameArray.value,index)"
            >{{segmentNameArray.show}}</md-checkbox>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="20">
                <label for="shipmentType">CC Type</label>
                <model-list-select
                  :list="ccInhouseList"
                  isDisabled
                  v-model="ffExoprtDetail.ccInhouse"
                  option-value="shipmentTypeVal"
                  option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"
                ></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label for="containerInfo">FF Activity *</label>
                <model-list-select
                  isDisabled
                  :list="containerInfoList"
                  v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal"
                  option-text="containerInfoText"
                  placeholder="Select Activity"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.containerInfo">{{
                  ffExporterrorList.containerInfo
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label>Forwarder Name *</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="forwarderName"
                  name="forwarderName"
                  v-model="ffExoprtDetail.forwarderName"
                ></b-form-input>
                <span class="error" v-if="!ffExoprtDetail.forwarderName">{{
                  ffExporterrorList.forwarderName
                }}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="50">
                <label for="shippingId"
                  >{{
                    ffExoprtDetail.shipmentType == 1 &&
                    ffExoprtDetail.transportType == "Export" &&
                    ffExoprtDetail.containerInfo == "lcl" &&
                    ffExoprtDetail.multipleContainerType == "LCL Container"
                      ? "Coloder Name"
                      : "Shipping Line Name"
                  }}
                  *</label
                >
                <model-list-select
                  :list="shippingList"
                  v-model="ffExoprtDetail.shippingId"
                  option-value="shippingId"
                  option-text="shippingLine"
                  placeholder="Select Shipping Line"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shippingId">{{
                  ffExporterrorList.shippingId
                }}</span>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="85"></md-layout>
          <md-layout md-flex="15">
            <h4 style="margin:0px" class="showMoreData" >Add More Fields</h4>
          </md-layout>
            </md-layout>-->
            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="40">
                <label>Booking No.</label>
                <b-form-input :formatter="capitalizeAll" id="bookingNo" name="bookingNo" v-model="ffExoprtDetail.bookingNo"></b-form-input>
                <span class="error" v-if="!ffExoprtDetail.bookingNo">{{ffExporterrorList.bookingNo}}</span>
              </md-layout>
              <b-button
                variant="info"
                size="sm"
                style="margin-top:40px;margin-left:5px"
                @click="addAdditional"
              >Add More</b-button>
            </md-layout>
            <md-layout
              gutter
              v-for="(item,index) in ffExoprtDetail.multiBookingNo"
              :key="index"
              class="gutr"
            >
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="40">
                <label>Booking No.{{index + 2}}</label>

                <b-form-input :formatter="capitalizeAll" v-model="ffExoprtDetail.multiBookingNo[index]"></b-form-input>
              </md-layout>

              <md-layout md-flex="15">
                <md-button
                  style="margin-top:35px; margin-right:50px; height: 10px;  width: 39px;"
                  @click="removeNotify(index)"
                  class="md-fab md-fab-top"
                >
                  <md-icon>remove</md-icon>
                </md-button>
              
              </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="clientId">Exporter Name *</label>

                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.exporterClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Exporter Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{
                  ffExporterrorList.exporterClientId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label for="clientId">Importer Name *</label>

                <model-list-select
                  isDisabled
                  :list="clientList"
                  id="clientNamenew"
                  v-model="ffExoprtDetail.importerClientId"
                  option-value="clientId"
                  option-text="clientName"
                  placeholder="Select Importer Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.importerClientId">{{
                  ffExporterrorList.importerClientId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr" v-if="openExpoInput == true">
              <md-layout md-flex="50"></md-layout>
              <md-layout md-flex="50">
                <label for="clientId">Importer Name</label>

                <b-form-input
                  :formatter="capitalizeAll"
                  id="otherExpoName"
                  name="otherExpoName"
                  v-model="ffExoprtDetail.otherImpoName"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="15">
            <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="containerSealed">Stuffing Type *</label>
                <model-list-select
                  :list="containerSealedList"
                  v-model="ffExoprtDetail.containerSealed"
                  option-value="containerSealedV"
                  option-text="containerSealedT"
                  placeholder="Select "
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.containerSealed">{{
                  ffExporterrorList.containerSealed
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label>Line Seal No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="lineSealNo"
                  name="lineSealNo"
                  v-model="ffExoprtDetail.lineSealNo"
                ></b-form-input>
              </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Custom Seal No.</label>
                <b-form-input :formatter="capitalizeAll"
                  disabled
                  id="customSealNo"
                  name="customSealNo"
                  v-model="ffExoprtDetail.customSealNo"
                ></b-form-input>
              </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>RFID Seal No.</label>
            <b-form-input :formatter="capitalizeAll" id="rfidSealNoF" name="rfidSealNoF" v-model="ffExoprtDetail.rfidSealNoF"></b-form-input>
              </md-layout>-->
            </md-layout>
            <!--  <md-layout md-gutter class="gutr">
        
        <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label>RFID Seal No.</label>
            <b-form-input :formatter="capitalizeAll" id="rfidSealNoW" name="rfidSealNoW" v-model="ffExoprtDetail.rfidSealNoW"></b-form-input>
          </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label>{{
                  ffExoprtDetail.containerInfo == "lcl"
                    ? "Measurement(L x B x H)cm/inch"
                    : "Gross Wgt"
                }}</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="Measurement"
                  name="Measurement"
                  v-model="ffExoprtDetail.measurement"
                ></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label>{{
                  ffExoprtDetail.containerInfo == "lcl" ? "CBM" : "Net Wgt"
                }}</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="CBM"
                  name="CBM"
                  v-model="ffExoprtDetail.CBM"
                ></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>No. Of Packages</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  type="number"
                  id="noOfPackage"
                  name="noOfPackage"
                  v-model="ffExoprtDetail.noOfPackage"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="PORlocationId">Place of Receipt *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'All', 'IcdPOrtList')"
                  @searchchange="getLocationList($event, 'All', 'IcdPOrtList')"
                  :list="IcdPOrtListNew"
                  v-model="ffExoprtDetail.PORlocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Place of Receipt"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{
                  ffExporterrorList.PORlocationId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label for="LPlocationId">Load Port Name *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')"
                  @searchchange="
                    getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')
                  "
                  :list="PortLoadList"
                  v-model="ffExoprtDetail.LPlocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select Load Port Name"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.LPlocationId">{{
                  ffExporterrorList.LPlocationId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="PODLocationId">Port of Discharge *</label>
                <model-list-select
                  isDisabled
                  @input="
                    getLocationList($event, 'Sea_Port,Air_Port', 'getPortDischargeList')
                  "
                  @searchchange="
                    getLocationList($event, 'Sea_Port,Air_Port', 'getPortDischargeList')
                  "
                  :list="getPortDischargeList"
                  v-model="ffExoprtDetail.PODLocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POD"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{
                  ffExporterrorList.PODLocationId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50">
                <label for="finalPlaceLocationId">Final Place of Delivery *</label>
                <model-list-select
                  isDisabled
                  @input="getLocationList($event, 'All', 'finalAllPlaceData')"
                  @searchchange="getLocationList($event, 'All', 'finalAllPlaceData')"
                  :list="finalAllPlaceData"
                  v-model="ffExoprtDetail.finalPlaceLocationId"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select FPOD"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.finalPlaceLocationId">{{
                  ffExporterrorList.finalPlaceLocationId
                }}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="pdaDetail">PDA Details *</label>
                <model-list-select
                  :list="pdaDetailList"
                  v-model="ffExoprtDetail.pdaDetail"
                  option-value="pdaDetailsVal"
                  option-text="pdaDetailsText"
                  placeholder="Select PDA "
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.pdaDetail">{{
                  ffExporterrorList.pdaDetail
                }}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="80">
                <label for="autoCommodity">Commodity *</label>
                <!-- <model-list-select
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemDescription"
                  placeholder="Select Commodity"
                ></model-list-select> -->
                <model-list-select
                  @searchchange="getCommodityList($event, 'getCommodityData')"
                  :list="commodityList"
                  v-model="ffExoprtDetail.commodityId"
                  option-value="commodityId"
                  option-text="itemHSNCode"
                  placeholder="Select Commodity"
                ></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.commodityId">{{
                  ffExporterrorList.commodityId
                }}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <b-button
                  variant="primary"
                  @click="openCommodityModal()"
                  id="addButtonLoader"
                  size="sm"
                  style="margin-top: 40px"
                  >Add</b-button
                >
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="45">
            <md-layout md-flex="100">
              <label for="commodityType">Commodity Type</label>

              <b-form-input :formatter="capitalizeAll"
                id="commodityType"
                name="commodityType"
                disabled
                v-model="ffExoprtDetail.commodityType"
              ></b-form-input>
            </md-layout>
              </md-layout>-->
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="45">
                <label for="commodityType">Commodity Type</label>
                <model-list-select
                  :list="commodityTypeName"
                  v-model="ffExoprtDetail.commodityType"
                  option-value="commodityTypeVal"
                  option-text="commodityTypeText"
                  placeholder="Select Commodity Type"
                ></model-list-select>
              </md-layout>
            </md-layout>
            <!-- <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label for="itemDescription">Item Description</label>

              <b-form-textarea :formatter="capitalizeAll"
                id="itemDescription"
                name="itemDescription"
                disabled
                v-model="ffExoprtDetail.itemDescription"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
            </md-layout>-->
            <md-layout
              md-gutter
              class="gutr"
              v-if="ffExoprtDetail.commodityType == 'Hazardous'"
            >
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>IMDG Class</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="IMDGClass"
                    name="IMDGClass"
                    v-model="ffExoprtDetail.IMDGClass"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>UN Number</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="UNNumber"
                    name="UNNumber"
                    v-model="ffExoprtDetail.UNNumber"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Packing Code</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="packingCode"
                    name="packingCode"
                    v-model="ffExoprtDetail.packingCode"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              class="gutr"
              v-if="ffExoprtDetail.commodityType == 'Reefer'"
            >
              <md-layout md-flex="45">
                <md-layout md-flex="100">
                  <label>Temperature Req(Degree Celsius)</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="temperatureRequired"
                    name="temperatureRequired"
                    v-model="ffExoprtDetail.temperatureRequired"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout
              md-gutter
              class="gutr"
              v-if="ffExoprtDetail.commodityType == 'Others'"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Specific Detail if any..!</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="otherComodity"
                    name="otherComodity"
                    v-model="ffExoprtDetail.otherComodity"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr mt-3">
              <md-layout md-flex="15">
                <!-- Other Services -->

                <h5>
                  <b-badge>Additional Task</b-badge>
                </h5>
              </md-layout>
            </md-layout>
            <md-layout md-gutter>
              <md-layout
                v-for="(otherServiceNameArray, index) in showOtherServiceArray"
                :key="index"
                :md-flex="otherServiceNameArray.flex"
              >
                <md-checkbox
                  v-model="ffExoprtDetail.otherServices[index]"
                  class="md-primary"
                  :md-value="otherServiceNameArray.value"
                  :name="'otherServices' + (index + 1)"
                  :id="'otherServices' + (index + 1)"
                  @change="
                    otherServiceNameArraySelect(otherServiceNameArray.value, index)
                  "
                  >{{ otherServiceNameArray.show }}</md-checkbox
                >
              </md-layout>
            </md-layout>

            <!-- <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
             
                <label>
                  <b>
                    <u>More Additional Task</u>
                  </b>
                </label>
              </md-layout>
            </md-layout>

            <md-layout md-gutter>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-input-container>
                  <md-select
                    placeholder="Click For More Additional Task"
                    name="additionalMoreTask"
                    id="additionalMoreTask"
                    multiple
                    v-model="ffExoprtDetail.additionalMoreTask"
                    @change="showMultiple"
                  >
                    <md-option
                      v-for="(AdditionalMoreArray,index) in showAdditionalMoreTaskArray"
                      :key="index"
                      :value="AdditionalMoreArray"
                    >{{AdditionalMoreArray.show}}</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
            </md-layout> -->
            <md-layout md-gutter v-if="showAdd" class="gutr">
              <md-layout md-flex="5"></md-layout>
              <!--  -->
              <md-layout md-flex="40">
                <md-layout md-flex="100">
                  <label>Specify Additional Task</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="specificAdditionalTask"
                    name="specificAdditionalTask"
                    v-model="ffExoprtDetail.specificAdditionalTask"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout
              md-gutter
              v-if="specialInstruction != null && specialInstruction != ''"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label>Special Instruction</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="remark"
                    name="remark"
                    v-model="specialInstruction"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <label for="itemDescription">Remark</label>

                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="remark"
                    name="remark"
                    v-model="ffExoprtDetail.remark"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <div class="gutr">
              <b-button
                class="mt-3"
                variant="primary"
                id="addButtonLoaderLast"
                @click="addCCExport('0')"
                >Save & Submit</b-button
              >
              <!-- <md-spinner md-indeterminate id="loaderLast" style="display:none"></md-spinner> -->
            </div>
            <div class="mt-1">
              <b-button
                variant="primary"
                id="addButtonLoaderLast"
                @click="addCCExport('qqqqq')"
                >Save & Proceed to Edi Execution</b-button
              >
              <!-- <md-spinner md-indeterminate id="loaderLast" style="display:none"></md-spinner> -->
            </div>

            <b-col lg="12">
              <span class="error pull-right" v-if="ffExoprtDetail.CCExportDetailsCreated">
                <b> {{ ffExoprtDetail.CCExportDetailsCreated }}</b>
              </span>  
            </b-col>
            
            <b-col lg="12">
              <span class="error pull-right" v-if="ffExoprtDetail.CCExportDetailsUpdated">
                <b> {{ ffExoprtDetail.CCExportDetailsUpdated }}</b>
              </span>  
            </b-col>

            <!-- <b-col lg="12"> {{ ffExoprtDetail }} </b-col> -->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
      <!-- Commodity Modal Added By Priyanshu Singh Start -->
      <b-modal
        no-close-on-esc
        no-close-on-backdrop
        size="xl"
        ref="Commodity-modal"
        hide-footer
        title=""
      >
        <div class="d-block text-center">
          <h3>Add Commodity</h3>
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-row>
              <b-col md="4" class="text-right">
                <label>Item Name <span class="error">*</span></label>
              </b-col>
              <b-col md="8" class="my-1">
                <b-form-input
                  size="sm"
                  :formatter="capitalizeAll"
                  id="itemName"
                  name="itemName"
                  v-model="commodityModal.itemName"
                ></b-form-input>
                <span class="error" v-if="!commodityModal.itemName">{{
                  errorList.itemName
                }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="4" class="text-right">
                <label>HSN Code <span class="error"></span></label>
              </b-col>
              <b-col md="8" class="my-1">
                <b-form-input
                  size="sm"
                  :formatter="capitalizeAll"
                  id="hsnCode"
                  name="hsnCode"
                  v-model="commodityModal.hsnCode"
                ></b-form-input>
                <span class="error" v-if="!commodityModal.hsnCode">{{
                  errorList.hsnCode
                }}</span>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="5" class="my-1"></b-col>
          <b-col md="2" class="my-1">
            <b-button
              variant="primary"
              @click="addCommodity"
              id="addButtonLoader"
              size="sm"
              >Save</b-button
            >
            <b-button variant="outline-danger" size="sm" @click="hideCommodityModal"
              >Close</b-button
            >
            <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
          </b-col>
          <b-col md="5" class="my-1"></b-col>
        </b-row>
      </b-modal>
      <!-- Commodity Modal Added By Priyanshu Singh Start -->
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseAddSeaImp"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="message"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
  GlobalGetCommodity2,
  GlobalContainerValid,
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import ffExportFclVue from "../freightForwarding/ffExportFcl.vue";

export default {
  beforeMount() {
    if (globalPermissionStatus("Custom Clearance")) {
      this.$store.dispatch("setCurrentRoute", "/CCImport/CCExportEntry");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    // CommodityAll: {
    //   handler: function(newVal, oldVal) {
    //     this.CommodityCallback(newVal);
    //   },
    //   deep: true
    // },
    containerModal: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.containerModal.containerNo = newVal.containerNo.toUpperCase();
        }
      },
      deep: true,
    },
    ffExoprtDetail: {
      handler: function (newVal, oldVal) {
        if (this.ffExoprtDetail.importerClientId != "") {
          let dummyExporter = this.getCLientData.filter((x) => {
            return x.clientId == this.ffExoprtDetail.importerClientId;
          });
          if (dummyExporter.length > 0) {
            if (dummyExporter[0].clientName == "Others") {
              this.openExpoInput = true;
            } else {
              this.openExpoInput = false;
            }
          }
          if (newVal.PODLocationId != "") {
            let arraySI = this.PortDischargeList.filter((x) => {
              return x.pickupId == newVal.PODLocationId;
            });

            if (arraySI.length > 0) {
              this.specialInstruction = arraySI[0].specialInstruction;
            }
          }
          if (newVal.PORlocationId != "") {
            let arraySeaPort = this.IcdPOrtListNew.filter((x) => {
              return x.pickupId == newVal.PORlocationId;
            });

            if (arraySeaPort.length > 0) {
              console.log(arraySeaPort, "uyu");
              this.ffExoprtDetail.portType = arraySeaPort[0].locationType;
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // Added vy Priyanshu Singh Start
      commodityModal: {
        commodityNewId: "",
        itemName: "",
        hsnCode: "",
      },
      CommodityError: [
        "Please Enter ItemName",
        // "Please Enter HSNCode",
      ],
      errorList: {
        itemName: "",
        // hsnCode: "",
      },
      // Added vy Priyanshu Singh End
      showAdd: false,
      specialInstruction: "",
      isLoading: false,
      conDetailsTPT: "",
      containerSealedList: [
        {
          containerSealedV: "Factory",
          containerSealedT: "Factory",
        },
        {
          containerSealedV: "WareHouse",
          containerSealedT: "WareHouse",
        },
      ],
      ccInhouseList: [
        {
          shipmentTypeVal: "CC_Inhouse",
          shipmentTypeText: "CC INHOUSE",
        },
      ],
      pdaDetailList: [
        {
          pdaDetailsVal: "Pridel",
          pdaDetailsText: "Pridel",
        },
        {
          pdaDetailsVal: "Shipper",
          pdaDetailsText: "Shipper",
        },
        {
          pdaDetailsVal: "Liner",
          pdaDetailsText: "Liner",
        },
        {
          pdaDetailsVal: "NA",
          pdaDetailsText: "Not Applicable",
        },
      ],
      commodityTypeName: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "DANGEROUS CARGO (HAZ)",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "TEMPERATUR CONTROLLED ( REEFER)",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL (OTHERS)",
        },
      ],
      commodityTypeName_bak: [
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "Hazardous",
        },
        {
          commodityTypeVal: "Non_Hazardous",
          commodityTypeText: "Non Hazardous",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "Reefer",
        },
        {
          commodityTypeVal: "Others",
          commodityTypeText: "Others",
        },
      ],

      containerInfoList: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL",
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL",
        },
      ],
      blRegexError: "",
      openExpoInput: false,
      docURL: URL_BASE_DOC,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showAlgo: false,
      algoConNo: "",
      CommodityAll: {},
      autoClientName: {},
      showAdditionalMoreTaskArray: [],
      showOtherServiceArray: [],
      containerArray: [],
      ffExoprtDetail: {
        portType: "",
        otherImpoName: "",
        ccImportId: "",
        jobType: [],
        otherServices: [],
        additionalMoreTask: [],
        ccInhouse: "CC_Inhouse",
        ccType: "Export",
        containerInfo: "",
        forwarderName: "",
        bookingNo: "",
        multiBookingNo: [],
        shippingId: "",
        exporterClientId: "",
        importerClientId: "",
        containerSealed: "",
        lineSealNo: "",
        rfidSealNoF: "",
        customSealNo: "",
        rfidSealNoW: "",
        measurement: "",
        CBM: "",
        noOfPackage: "",
        commodityId: "",
        commodityType: "",
        itemDescription: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        pdaDetail: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        specificAdditionalTask: "",
        remark: "",
        statusFinalExp: "",

        //
        FreghtAssignId: "",
        splitCCAssign: "0",
        allModuleId: "",
        ccImportSeries: "",
        ccConModal: [],
        splitContainerArry: [],

        CCExportDetailsCreated: "",
        CCExportDetailsUpdated: "",
      },
      ALLMODULE: "",
      JOBSERIES: "",
      containerModal: {
        containerBookingNo: "",
        containerSealNo: "",
        ccContanerId: "",
        containerNo: "",
        allSame: "0",
        containerTypeId: "",
        bookingUpload: "",
        customSeal: "",
        grossWgt: "",
        netWgt: "",
        packageId: "",
        quantity: "",
      },
      getPortData: ["Agra"],
      getCLientData: ["gfdg"],
      showSegmentArray: [],

      ffExportError: {
        containerInfo: "Select FF Activity",
        forwarderName: "Select Forwarder Name",
        // bookingNo: "Enter Booking No",
        shippingId: "Select ShippingLine",
        exporterClientId: "Select Exporter Name",
        importerClientId: "Select Importer Name",
        containerSealed: "Select Sontainer Sealed Info",
        pdaDetail: "Select PDA Details",
        PORlocationId: "Select Place of Receipt",
        LPlocationId: "Select Load Port",
        PODLocationId: "Select Port Of Discharge",
        finalPlaceLocationId: "Select Final Place of Delivery",
        commodityId: "Select Commodity",
      },
      ffExporterrorList: {
        containerInfo: "",
        forwarderName: "",
        // bookingNo: "",
        shippingId: "",
        exporterClientId: "",
        importerClientId: "",
        containerSealed: "",
        pdaDetail: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        commodityId: "",
      },
      containererrorList: {
        containerTypeId: "",
        containerNo: "",
      },
      containerError: {
        containerTypeId: "Select Container type",
        containerNo: "Enter Container No",
      },
      CC_EDI: "",
      CC_BL: "",
      CC_VGM: "",
      CC_HAND: "",
      CC_PAY: "",

      getPortDischargeList: [],
      finalAllPlaceData: [],

      jobTypeSelectVal: false,
      otherServicesVal: false,
      showConDiv: false,

      getShippingLineData: ["zim"],
      packageNameList: [],
      // freghtMultiExec: [],
      getCommodityData: ["zim"],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: [],
      PortLoadList: [],
      validate: true,

      ExecutionDisable: "",
      noOfContainerError: "",
      containerTypeIdError: "",
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    DocForm,
    BannerComponent,
  },
  computed: {
    containerCheck() {
      if (this.ffExoprtDetail.containerSealed == "Factory") {
        if (this.containerArray.length > 0) {
          let array = this.containerArray.filter((x) => {
            return x.containerNo;
          });
          return array.length == this.containerArray.length ? true : false;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },

    commodityList() {
      return this.getCommodityData;
    },
  },
  methods: {
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    onFileChange(index, ID) {
      let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("moduleId", this.$sessionsStorage.get("editCcImportId"));
        if (ID == "BOOK") {
          formData.append("staticFileName", "CC_Export_BOOKING_DOC");
        }

        formData.append("upload_dir_folderName", "CC_Export_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then((result) => {
          if (ID == "BOOK") {
            this.containerModal.bookingUpload = result.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    gotToPage(ID) {
      if (ID == "EDI") {
        this.$router.push({
          path: "/CCImport/newEdiExecution",
        });
      } else if (ID == "BL") {
        this.$router.push({
          path: "/CCImport/ccExBL",
        });
      } else if (ID == "PAY") {
        this.$router.push({
          path: "/CCImport/paymentDetail",
        });
      } else if (ID == "HAND") {
        this.$router.push({
          path: "/CCImport/newCCHandoverToRail",
        });
      } else if (ID == "VGM") {
        this.$router.push({
          path: "/CCImport/newCCExVgm",
        });
      } else {
        console.log("no");
      }
    },
    // onChangeSplitSelect(item) {
    //   if (item.containerNo == "" || item.containerBookingNo == "") {
    //     this.alert.content =
    //       "Please Enter all Details of Containers to be splited..!";

    //     this.$refs["message"].open();
    //     this.ffExoprtDetail.splitCCAssign = false;
    //   }
    // },
    // getFFcon() {
    //   let arrySelectFF = this.freghtMultiExec.filter(x => {
    //     return x.ffExportFclId == this.ffExoprtDetail.FreghtAssignId;
    //   });
    //   if (arrySelectFF.length > 0) {
    //     this.containerArray = [];
    //     let conNo = arrySelectFF[0].ContainerNumberFF.split(",");
    //     let conType = arrySelectFF[0].ContainerTypeFF.split(",");
    //     for (let r = 0; r < conType.length; r++) {
    //       console.log(r);
    //       let obj = {
    //         containerNo: conNo[r],
    //         containerType: conType[r]
    //       };
    //       this.containerArray.push(obj);
    //     }
    //   }
    // },
    getConAlgoList() {
      //let self = this;

      if (this.containerModal.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(this.containerModal.containerNo);
      }
    },
    getCommodityList(event, vmodelArray) {
      let vehicle_drive = {
        value: event,
      };

      let self = this;

      if (event != "") {
        GlobalGetCommodity2(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              console.log(self[vmodelArray]);
            }
          }
        });
      }
    },
    editContainer(item) {
      this.containerModal.ccContanerId = item.ccContanerId;
      this.containerModal.containerNo = item.containerNo;
      this.containerModal.containerTypeId = item.containerTypeId;
      this.containerModal.containerBookingNo = item.containerBookingNo;
      this.containerModal.containerSealNo = item.containerSealNo;
      this.containerModal.grossWgt = item.grossWgt;
      this.containerModal.customSeal = item.customSeal;
      this.containerModal.netWgt = item.netWgt;
      this.containerModal.packageId = item.packageId;
      this.containerModal.quantity = item.quantity;
      this.showConDiv = true;
    },
    addAdditional() {
      let bookingNo = "";

      this.ffExoprtDetail.multiBookingNo.push(bookingNo);
    },
    removeNotify(index) {
      this.ffExoprtDetail.multiBookingNo.splice(index, 1);
      //  this.errorMultiContainer.splice(index, 1);
    },
    addStatus() {
      let data = {
        jobType: "2",
        typeOf: "2",
        allMessageId: this.$sessionsStorage.get("editCcImportId"),
        statusMain: this.ffExoprtDetail.statusFinalExp,
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus",
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;

      var blformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];

      if (blformat.test(this.containerModal.containerNo)) {
        this.blRegexError = "";
      } else {
        this.blRegexError = "Enter Valid Format";
      }
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map((x) => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },

    onCloseAddSeaImp() {
      this.$router.push({
        path: "/CCImport/newEdiExecution",
      });
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.ffExoprtDetail.jobType = Array(this.showSegmentArray.length).fill(true);
          this.jobTypeSelectVal = true;
        } else {
          this.ffExoprtDetail.jobType = Array(this.showSegmentArray.length).fill(false);
          this.jobTypeSelectVal = false;
        }
      }
    },

    validateCCExport(id) {
      let validate_new = true;
      // if (this.ffExoprtDetail.containerInfo == "fcl") {
      if (id == "") {
        Object.keys(this.ffExporterrorList).map((x) => {
          if (this.ffExoprtDetail[x] == "") {
            this.ffExporterrorList[x] = this.ffExportError[x];
            validate_new = false;
          }
        });
        Object.keys(this.containererrorList).map((x) => {
          if (this.containerModal[x] == "") {
            this.containererrorList[x] = this.containerError[x];
            validate_new = false;
          }
        });
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCCExport(id) {
      // if (id == "") {
      //   let arry = this.containerArray.filter(p => {
      //     return p.containerNo == this.containerModal.containerNo;
      //   });
      //   if (arry.length > 0) {
      //     this.alert.content = "Container No. Already Exists..!";

      //     this.$refs["message"].open();
      //     return false;
      //   }
      // }

      let newVal = [];
      let newValOther = [];
      let newAdditionalTask = [];

      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });
      this.showOtherServiceArray.map((x, index) => {
        if (this.ffExoprtDetail.otherServices[index] == true) {
          newValOther.push(x.value);
        }
      });

      this.ffExoprtDetail.additionalMoreTask.map((x, index) => {
        newAdditionalTask.push(x.value);
      });

      this.ffExoprtDetail.ccConModal.map((p, index1) => {
        if (p != false) {
          this.ffExoprtDetail.splitContainerArry.push(p);
        }
      });

      this.ffExoprtDetail["jobType"] = newVal;
      this.ffExoprtDetail["otherServices"] = newValOther;
      this.ffExoprtDetail["additionalMoreTask"] = newAdditionalTask;
      this.containerModal["ccImportId"] = this.$sessionsStorage.get("editCcImportId");

      this.validateCCExport(id);

      let new_data = {
        ffExoprtDetail: this.ffExoprtDetail,
        containerModal: this.containerModal,
        onlyExecMain: "",
      };

      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "csfds";
      }

      if (this.validate != false) {
        if (id != "") {
          $("#addButtonLoaderLast").css("display", "none");
          $("#loaderLast").css("display", "block");
        } else {
          $("#addButtonLoaderCon").css("display", "none");
          $("#loaderCon").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Custom/addCCExport.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              this.$sessionsStorage.set("editCcImportId", data.ccImportId);
              console.log(data);
              this.ffExoprtDetail.ccImportId = data.ccImportId;
              if (id != "") {
                $("#loaderLast").css("display", "none");
                $("#addButtonLoaderLast").css("display", "block");
              } else {
                $("#loaderCon").css("display", "none");
                $("#addButtonLoaderCon").css("display", "block");
              }

              if (id != "") {
                this.$sessionsStorage.set("editCcType", "Export");
                this.alert.content = "Data Updated Succesfully";
                if (id == "0") {
                  this.$refs["message"].open();
                } else {
                  this.$refs["alertAddSeaImp"].open();
                }
              }
              this.showConDiv = false;
              if (id == "0") {
                this.getData();
              }
            }
          })
          .catch((error) => {});
      }
    },

    getData() {
      this.doLoading();
      let arrayJob = [];
      let arrayOther = [];
      let arrayAdditional = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ccImportId: this.$sessionsStorage.get("editCcImportId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Custom/getDataCCExport_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);

            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }
            console.log("data.CommodityData1SQL=>", data.CommodityData1SQL);
            console.log("data.CommodityDataSQL=>", data.CommodityDataSQL);
            console.log("data.CommodityData=>", data.CommodityData);
            if (data.CommodityData_new.length > 0) {
              // this.getCommodityData = data.CommodityData;
              this.getCommodityData = data.CommodityData_new;
            }
            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }
            // if (data.freghtMultiExec.length > 0) {
            //   this.freghtMultiExec = data.freghtMultiExec;
            // }
            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            }

            if (data.ccEntryExportData.length > 0) {
              this.ALLMODULE = data.ccEntryExportData[0].allModuleId;
              this.JOBSERIES = data.ccEntryExportData[0].ccImportSeries;
              const objarray = Object.keys(data.ccEntryExportData[0]);
              this.clientName = "";
              data.clientdetail.forEach((user) => {
                if (user.clientId == data.ccEntryExportData[0].exporterClientId) {
                  this.clientName = user.clientName;
                }
              });

              objarray.map((p) => {
                // console.log("p=>",p)
                // if (p == "jobType") {
                //   arrayJob = data.ccEntryExportData[0][p].split(",") || [];
                // } else if (p == "otherServices") {
                //   if (data.ccEntryExportData[0][p] != "") {
                //     arrayOther = data.ccEntryExportData[0][p].split(",") || [];
                //   } else {
                //     arrayOther = [];
                //   }
                // } else if (p == "multiBookingNo") {
                //   console.log("Priyanshu1=>", data.ccEntryExportData[0][p]);
                //   if (data.ccEntryExportData[0][p] != '' && data.ccEntryExportData[0][p] != null && data.ccEntryExportData[0][p] != undefined) {
                //     console.log("Priyanshu2=>", data.ccEntryExportData[0][p]);
                //     this.ffExoprtDetail[p] = data.ccEntryExportData[0][p]
                //       ? data.ccEntryExportData[0][p].split(",")
                //       : [];
                //   }
                // } else if (p == "additionalTask") {
                //   console.log("Priyanshu=>", data.ccEntryExportData[0][p]);
                //   if (data.ccEntryExportData[0][p] != "") {
                //     console.log(data);
                //     arrayAdditional = data.ccEntryExportData[0][p].split(",") || [];
                //   } else {
                //     arrayAdditional = [];
                //   }
                // } else {
                this.ffExoprtDetail[p] = data.ccEntryExportData[0][p] || "";
                // }
                if (p == "jobType") {
                  arrayJob = data.ccEntryExportData[0][p].split(",") || [];
                }
                if (p == "otherServices") {
                  if (data.ccEntryExportData[0][p] != "") {
                    arrayOther = data.ccEntryExportData[0][p].split(",") || [];
                  } else {
                    arrayOther = [];
                  }
                }
                if (p == "multiBookingNo") {
                  console.log("Priyanshu1=>", data.ccEntryExportData[0][p]);
                  if (
                    data.ccEntryExportData[0][p] != "" &&
                    data.ccEntryExportData[0][p] != null &&
                    data.ccEntryExportData[0][p] != undefined
                  ) {
                    console.log("Priyanshu2=>", data.ccEntryExportData[0][p]);
                    this.ffExoprtDetail[p] = data.ccEntryExportData[0][p]
                      ? data.ccEntryExportData[0][p].split(",")
                      : [];
                  }
                }
                if (p == "additionalTask") {
                  console.log("Priyanshu=>", data.ccEntryExportData[0][p]);
                  if (data.ccEntryExportData[0][p] != "") {
                    console.log(data);
                    arrayAdditional = data.ccEntryExportData[0][p].split(",") || [];
                  } else {
                    arrayAdditional = [];
                  }
                }
              });
              this.ffExoprtDetail["jobType"] = [];
              this.ffExoprtDetail["otherServices"] = [];
              this.ffExoprtDetail["additionalMoreTask"] = [];

              // this.showAdditionalMoreTaskArray.map((x, index) => {
              //   let i = arrayAdditional.indexOf(x.value);
              //   // console.log(array, i);

              //   i >= 0 ? this.ffExoprtDetail.additionalMoreTask.push(x) : "";
              // });
              console.log("showSegmentArray=>", this.showSegmentArray);
              this.showSegmentArray.map((x, index) => {
                let i = arrayJob.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });

              this.showOtherServiceArray.map((x, index) => {
                let i = arrayOther.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.otherServices[index] = true)
                  : (this.ffExoprtDetail.otherServices[index] = false);
              });

              this.CommodityAll = this.getCommodityData.filter((x) => {
                return x.commodityId == data.ccEntryExportData[0].commodityId;
              })[0];
              if (data.ccEntryExportData[0]["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsFinal;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.finalAllPlaceData = data.LocationDetailsFinal;

            this.CC_EDI = data.CC_EDI;
            this.CC_BL = data.CC_BL;
            this.CC_VGM = data.CC_VGM;
            this.CC_HAND = data.CC_HAND;
            this.CC_PAY = data.CC_PAY;
            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/CCImport/CCExportDetail",
      });
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20",
        },

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
      this.showOtherServiceArray = [
        {
          value: "Marking",
          show: "Marking/Labelling",
          flex: "15",
        },
        {
          value: "Palletization",
          show: "Palletization",
          flex: "15",
        },
        {
          value: "Fumigation",
          show: "Fumigation",
          flex: "15",
        },

        {
          value: "Lashing",
          show: "Lashing/Choking",
          flex: "15",
        },
        {
          value: "Legalization",
          show: "Legalization",
          flex: "15",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
          flex: "15",
        },
        {
          value: "Phyto",
          show: "Phyto",
          flex: "15",
        },

        {
          value: "APEDA",
          show: "APEDA",
          flex: "15",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
          flex: "15",
        },

        {
          value: " WildlifeNOC",
          show: " Wildlife NOC",
          flex: "15",
        },
        // {
        //   value: "OthersSpecify",
        //   show: " Others Specify"
        // }
        {
          value: "None",
          show: "None",
          flex: "15",
        },
      ];
      this.showAdditionalMoreTaskArray = [
        {
          value: "Legalization",
          show: "Legalization",
        },
        {
          value: "COC_GSP",
          show: "COC/GSP",
        },
        {
          value: "Phyto",
          show: "Phyto",
        },

        {
          value: "APEDA",
          show: "APEDA",
        },
        {
          value: "HealthCertificate",
          show: "Health Certificate",
        },

        {
          value: " WildlifeNOC",
          show: " Wildlife NOC",
        },
        {
          value: "OthersSpecify",
          show: " Others Specify",
        },
      ];
    },
    // Added By Priyanshu Singh Start
    openCommodityModal() {
      this.isLoading = false;
      this.$refs["Commodity-modal"].show();
    },
    hideCommodityModal() {
      this.$refs["Commodity-modal"].hide();
      this.isLoading = false;
    },
    validateCommodity() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.commodityModal[x] == "") {
          this.errorList[x] = this.CommodityError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addCommodity() {
      this.validateCommodity();
      if (this.validate != false) {
        this.commodityModal.type = "Normal";
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addCommodity_VP.php`,
          data: JSON.stringify(this.commodityModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              // alert(data.find);

              if (data.commodityNewId != "" && data.commodityNewId != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  this.commodityModal.commodityNewId = "";
                  this.commodityModal.itemName = "";
                  this.commodityModal.hsnCode = "";
                  if (data.CommodityData.length > 0) {
                    this.getCommodityData = data.CommodityData;
                  } else {
                    this.getCommodityData = [];
                  }
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.hideCommodityModal();
              console.log("MyData=>", data);
              console.log("Mystatus=>", status);
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    // Added By Priyanshu Singh End
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newCCExportEntry.vue?582b2306